export default __webpack_public_path__ + "static/LeituraSansTwo-BoldItalic-da5136fe7be1679cc0b9c34778d3aa76.woff2";